<template>
  <p-fip v-if="$hasPermission('docketing_tasks.read')" />
  <p-not-found v-else />
</template>

<script>
import NotFound from './../components/NotFound.vue';
import Fip from '../components/fip/Fip.vue';

export default {
  components: {
    'p-fip': Fip,
    'p-not-found': NotFound
  }
};
</script>
